import { Col, Label, Row } from 'reactstrap'
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown'
import Heading from '../../../../components/heading/Heading'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import styles from './RecipientInformation.styles'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import { HEADING } from '../../../../components/heading/constants/constants'
import { useDispatch, useSelector } from 'react-redux'
import Payer from '../../../../../libs/utility/Payer'
import { componentKey, setBulkAddressMatchModalOpen, setDeleteRecipientConfirmationModalOpen, setExportToExcelModal, setRequestConsentModalOpen, setShouldReloadPaginatedRecipientList,setSingleActivateReactivateModal } from '../RecipientListSlice'
import { setSelectedRecipient } from '../../RecipientsSectionSlice'
import { RECIPIENT_SECTION_ROUTES } from '../../constants'
import { setTinMatchConfirmationModalOpen } from '../tinmatchmodals/TinMatchSlice'
import Button from '../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import TxBadge from '../../../../components/badge/TxBadge'
import DateUtils from '../../../../../libs/utility/DateUtils'
import General from '../../../../../libs/utility/General'
import { blockTinRequest, downloadW8W9RequestPDF, unBlockTinRequest } from '../RecipientListSaga'
import { PAGE_PERMISSIONS } from '../../../dashboard/constants/constant'
import { setBulkW8RequestConfirmationModal } from '../bulkw8requestmodals/BulkW8RequestModalSlice'
import { setFirstConfirmationModalOpen } from '../bulkw9requestmodals/BulkW9RequestModalSlice'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import { isAccessAllowed, useUserPermissionsInfo } from '../../../dashboard/hooks/userHooks'
import { setShowPaymentNotAllowedPopup } from '../../../dashboard/DashboardSlice'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'
import { BLOCKED, FIELDS_TEXTS, MISSING_RECIPIENT_DATA_TEXT, TIN_STATUSES } from '../constants'
import { useEffect, useState } from 'react'

export default function RecipientInformation({
    hideTin= true
}) {

    const navigate = useTxNavigate()
    const dispatch = useDispatch();
    const { highlightedRecipient = {} } = useSelector((state) => state[componentKey]);

    const { FirstName = "", LastName, MiddleName, IdType, IdNumber, emailid, Address1, Address2, City, Country, ZipCode, AttentionTo, Phone, TypeofTIN, IsW9Filled, IsW8Filled, IsW9Request, IsW8Request, W9CreatedDate, W8CreatedDate, W8CompletedDate, W9CompletedDate, W8FormType, FormW9Id, RecipentDetailId } = highlightedRecipient;
    const { permissions } = useUserPermissionsInfo();
    const [recipentTinLabel , setRecipentTinLabel] = useState("");

    const isRecipientActive = (callback = () => { }) => {
        if (highlightedRecipient?.ISActive) {
            callback();
        } else {
            dispatch(addNotifications({ heading: "Error", message: "This action cannot be processed for inactive recipients" }));
        }
    }
    useEffect(() => {
        if (highlightedRecipient?.TinStatus === BLOCKED) {
            setRecipentTinLabel(TIN_STATUSES.UN_BLOCK_TIN_TEXT);
        }
        else if (highlightedRecipient?.TinStatus !== BLOCKED && highlightedRecipient?.TinStatus !== "") {
            setRecipentTinLabel(TIN_STATUSES.BLOCK_TIN_TEXT);
        }
        else {
            setRecipentTinLabel(TIN_STATUSES.TIN_REQUEST_TEXT);
        }

    }, [highlightedRecipient])

    const DROPDOWN_ACTION_ITEMS = [
        {
            itemName: recipentTinLabel,
            onClick: () => {
                    if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                        if(recipentTinLabel === TIN_STATUSES.BLOCK_TIN_TEXT){
                            if (highlightedRecipient && highlightedRecipient?.IdNumber && highlightedRecipient?.LastName) {
                                isRecipientActive(() =>  dispatch(blockTinRequest(highlightedRecipient)));
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: MISSING_RECIPIENT_DATA_TEXT }));
                            }
                        }
                        else if(recipentTinLabel === TIN_STATUSES.UN_BLOCK_TIN_TEXT){
                            if (highlightedRecipient && highlightedRecipient?.IdNumber && highlightedRecipient?.LastName) {
                                isRecipientActive(() => dispatch(unBlockTinRequest(highlightedRecipient)));
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: MISSING_RECIPIENT_DATA_TEXT }));
                            }
                        }
                        else{
                            if (highlightedRecipient && highlightedRecipient?.IdNumber && highlightedRecipient?.LastName) {
                                isRecipientActive(() => dispatch(setTinMatchConfirmationModalOpen(true)));
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: MISSING_RECIPIENT_DATA_TEXT }));
                            }
                        }
                    } else {
                        dispatch(setShowPaymentNotAllowedPopup(true));
                    }
            }
        },
        { itemName: "Bulk Address Match", onClick: () => isRecipientActive(() => dispatch(setBulkAddressMatchModalOpen(true))) },
        { itemName: "Export to excel", onClick: () => isRecipientActive(() => dispatch(setExportToExcelModal(true))) },
        {
            itemName: "Bulk W8 Request", onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    isRecipientActive(() => dispatch(setBulkW8RequestConfirmationModal(true)))
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            }
        },
        {
            itemName: "Bulk W9 Request", onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    isRecipientActive(() => dispatch(setFirstConfirmationModalOpen(true)))
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            }
        },
        {
            itemName: "Request Consent", onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    if (highlightedRecipient && General.arrayObjectsKeyIsNotEmpty([highlightedRecipient], FIELDS_TEXTS.EMAIL_ID_TEXT) && General.arrayObjectsKeyIsNotEmpty([highlightedRecipient], FIELDS_TEXTS.LASTNAME_TEXT) && General.arrayObjectsKeyIsNotEmpty([highlightedRecipient], FIELDS_TEXTS.IDNUMBER_TEXT)) {
                        isRecipientActive(() => dispatch(setRequestConsentModalOpen(true)))
                    }else{
                        dispatch(addNotifications({ heading: "Error", message: MISSING_RECIPIENT_DATA_TEXT }))
                    }
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            }
        },
        { itemName: highlightedRecipient?.ISActive ? "De-Activate" : "Activate", onClick: () => dispatch(setSingleActivateReactivateModal(true)) },
        {
            itemName: `Edit`, onClick: () => {
                dispatch(setSelectedRecipient(highlightedRecipient))
                navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}/${RECIPIENT_SECTION_ROUTES.EDIT}`)
            },
            permissions: PAGE_PERMISSIONS.EDIT_RECIPIENT
        },
        { itemName: "Delete", onClick: () => dispatch(setDeleteRecipientConfirmationModalOpen(true)), permissions: PAGE_PERMISSIONS.DELETE_RECIPIENT },
    ];

    return (
        <>
            <div style={styles.header}>

                <div style={styles.recipientNameContainer}>
                    <Icons familyName='vec' iconName={VEC_ICON_NAME.USER_ICON} />
                    <div>
                        <Heading type={HEADING.H2} >{`${FirstName || ""} ${MiddleName || ""} ${LastName || "N/A"}`}</Heading>
                        <span>{Payer.getPayerTINByIdType(IdType, IdNumber, hideTin) || "N/A"}</span>
                    </div>
                </div>
                <div>
                    <IconDropdown
                        label="Action"
                        dropdownItems={DROPDOWN_ACTION_ITEMS}
                        dropdownContainerStyles={styles.actionDropdown}
                        styles={styles.actionDropdownLabel}
                        dropdownMenuStyle={styles.actionDropdownMenu}
                    />
                </div>
            </div>

            <div style={styles.detailsContainer}>

                <Row style={styles.gapBetween}>
                    <Col lg={5} >
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.EMAIL_GREY_ICON} />
                        <span style={styles.detailsLabel}>{emailid || "N/A"}</span>
                    </Col>
                    <Col lg={5}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.PHONE_ICON} />
                        <span style={styles.detailsLabel}>{Phone || "N/A"}</span>
                    </Col>
                </Row>
                <Row style={styles.gapBetween}>
                    <Col lg={5}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.BUISNESS_ICON} />
                        <span style={styles.detailsLabel}>Attention To - {AttentionTo || "N/A"}</span>
                    </Col>
                </Row>
                <Row style={styles.gapBetween}>
                    <Col>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.HOME_ICON} />
                        <span style={styles.detailsLabel}>{`${Address1 || "N/A"}, ${Address2 ? Address2 + "," : ""} ${City || "N/A"}, ${ZipCode || "N/A"}, ${Country || "N/A"}`}</span>
                    </Col>
                </Row>

                <div style={styles.actionButtonsContainer}>
                    <div style={styles.actionItem}>
                        <div>
                            <span>W8-Status: </span>
                            <span style={styles.detailsLabel}>
                                {W8CompletedDate ? `W-8 Completed on – ${DateUtils.dateFormatter(W8CompletedDate, "MM/DD/YYYY")}` : (W8CreatedDate) ? `W-8 request sent on - ${DateUtils.dateFormatter(W8CreatedDate, "MM/DD/YYYY")}` : 'N/A'}
                            </span>

                            {IsW8Filled &&
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    style={styles.wButton}
                                    onClickCb={() => dispatch(downloadW8W9RequestPDF({ requestType: "W8-PDF", W8FormType, RecipentDetailId }))}
                                >
                                    Print W8 Request
                                </Button>
                            }
                        </div>
                        <div>
                            <span>W9-Status: </span>
                            <span style={styles.detailsLabel}>
                                {W8CompletedDate ? `W-9 Completed on – ${DateUtils.dateFormatter(W9CompletedDate, "MM/DD/YYYY")}` : (W9CreatedDate) ? `W-9 request sent on - ${DateUtils.dateFormatter(W9CreatedDate, "MM/DD/YYYY")}` : 'N/A'}
                            </span>
                            {IsW9Filled &&
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    style={styles.wButton}
                                    onClickCb={() => dispatch(downloadW8W9RequestPDF({ requestType: "W9-PDF", FormW9Id }))}
                                >
                                    Print W9 Request
                                </Button>}
                        </div>
                    </div>
                </div>


            </div>

            <HorizontalSeparator style={styles.horizontalLine} />

            <div style={styles.tinStatus}>
                <Heading>TIN Status : </Heading>
                <TxBadge bodyText={highlightedRecipient?.TinStatus || 'N/A'} color={General.tinStatusColor(highlightedRecipient?.TinStatus || 'N/A')} />
            </div>

            <div style={styles.tinStatus}>
                <Heading>TIN Checked Date : </Heading>
                <TxBadge bodyText={DateUtils.dateFormatter(highlightedRecipient?.TinCheckedDate) || "N/A"} />
            </div>

            <div style={styles.tinStatus}>
                <Heading>User Status : </Heading>
                <TxBadge color={General.tinStatusColor(highlightedRecipient?.ISActive ? "Active" : "In-Active" || 'N/A')} bodyText={highlightedRecipient?.ISActive ? "Active" : "In-Active" || 'N/A'} />
            </div>

            <div style={styles.tinStatus}>
                <Heading>Consent Status : </Heading>
                <TxBadge bodyText={highlightedRecipient?.ConsentStatus ? highlightedRecipient?.ConsentStatus : 'N/A'} />
            </div>
        </>
    )

}